import { instance } from '../../../../services';

// https://ckeditor.com/docs/ckeditor5/latest/framework/guides/deep-dive/upload-adapter.html#the-complete-implementation

export class UploadAdapter {
  constructor(loader) {
    this.loader = loader;
  }

  upload() {
    return this.loader.file.then(
      (file) =>
        new Promise((resolve, reject) => {
          const data = new FormData();
          data.append('file', file);

          let config = {
            onUploadProgress: (evt) => {
              this.loader.uploadTotal = evt.total;
              this.loader.uploaded = evt.loaded;
            },
          };

          instance
            .post('api/media/images', data, config)
            .then((response) => {
              return resolve({
                default: response.data.path,
              });
            })
            .catch((error) => {
              return reject(
                error.message ? error.message : 'An unknown error occurred',
              );
            });
        }),
    );
  }
}
